var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_vm._v("欢迎 "),_c('span',{staticStyle:{"color":"#409EFF"}},[_vm._v(_vm._s(_vm.adminName))]),_vm._v(" 登录使用"+_vm._s(_vm.platformName)+"~~~")])}
var staticRenderFns = []

export { render, staticRenderFns }